module.exports = __webpack_public_path__ + "static/learning-app-web-plp-87f030f0e192f0f3276e97d2de8bc374.png";